export enum InternalDBState {
    NOT_LOADED,
    LOADING,
    LOADED
}

export const INTERNAL_DB_CHANGED = 'internal-db:changed'